import React from 'react';
import { ProductLineWithPrice } from '../ProductLineWithPrice';
import { AppliedMealPlan, Upload } from 'services/BackendApi';
import { TCurrencyCode } from 'interfaces';
import { useCurrencyConversion } from 'context/CurrencyConversion/CurrencyConversionContext';

interface IAccommodationMealPlanProps {
  mealPlan: AppliedMealPlan;
  currencyCode: TCurrencyCode;
  uploads: Upload[];
  shouldHidePricing?: boolean;
}

export const AccommodationMealPlan: React.FC<IAccommodationMealPlanProps> = ({ mealPlan, currencyCode, uploads, shouldHidePricing }) => {
  const { convert } = useCurrencyConversion();
  const mealPlanDetails = {
    description: (mealPlan?.products || [])
      .map(item => {
        if (item.meta.description) {
          return `${item.name}\n${item.meta.description}`;
        }
        return item.name;
      })
      .join('\n'),
    title: 'Meal Plan Details',
    uploads: (uploads || []).filter(item => (mealPlan?.products || []).map(item => item.uuid).includes(item.ownerUuid)),
  };

  const mealPlanHasDescription = (mealPlan?.products || []).some(item => item.meta.description);

  return (
    <div className="meal-plans mt-[10px]">
      <ProductLineWithPrice
        name={mealPlan.products.map(p => p.name).join(', ')}
        total={mealPlan.total != null ? String(convert(mealPlan.total)) : null}
        totalBeforeDiscount={mealPlan.totalBeforeDiscount != null ? String(convert(mealPlan.totalBeforeDiscount)) : null}
        currencyCode={currencyCode}
        isOnRequest={mealPlan.isOnRequestOrPartiallyOnRequest}
        className="meal-plan"
        details={mealPlanDetails}
        showDescription={mealPlanHasDescription}
        shouldHidePricing={shouldHidePricing}
      />
    </div>
  );
};
